import * as Yup from 'yup';
/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable no-useless-escape */
export const InsuranceValidateSchema = Yup.object().shape({
  MEMBER_NUMBER: Yup.string()
    .max(20, 'Please enter no more than 20 characters')
    .required('Please enter Member Number/Id'),
  GROUP_NUMBER: Yup.string()
    .max(20, 'Please enter no more than 20 characters')
    .optional(),
  Q_Patient_relationship_to_subscriber: Yup.string().required(
    'Please enter Patient relationship to subscriber'
  ),
  SUBSCRIBER_FIRST_NAME_ON_CARD: Yup.string()
    .max(16, 'Please enter no more than 16 characters')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter First name on card'),
  SUBSCRIBER_MIDDLE_NAME_ON_CARD: Yup.string()
    .max(16, 'Please enter no more than 16 characters')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .optional(),
  SUBSCRIBER_LAST_NAME_ON_CARD: Yup.string()
    .max(26, 'Please enter no more than 26 characters')
    .matches(/^[a-zA-Z-]*$/, 'No numbers or special characters or space allowed')
    .required('Please enter Last name on card')
});

export const RELATIONSHIP_TYPE = [
  { label: 'Self', value: 'Self' },
  { label: 'Spouse', value: 'Spouse' },
  { label: 'Child', value: 'Child' },
  { label: 'Stepchild', value: 'Stepchild' },
  { label: 'Grandchild', value: 'Grandchild' },
  { label: 'Life Partner', value: 'Life Partner' },
  { label: 'Overage Dependent', value: 'Overage Dependent' },
  { label: 'Other', value: 'Other' }
];

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB

export interface RelationshipOptionsType {
  label: string;
  value: string;
}

export interface InsuranceInformationData {
  MEMBER_NUMBER: string;
  GROUP_NUMBER: string;
  Q_Patient_relationship_to_subscriber: string;
  SUBSCRIBER_FIRST_NAME_ON_CARD: string;
  SUBSCRIBER_MIDDLE_NAME_ON_CARD: string;
  SUBSCRIBER_LAST_NAME_ON_CARD: string;
}
